const EXPERIMENT_NAME = {
  NEW_LOGGED_OUT_SCREEN: 'NEW_LOGGED_OUT_SCREEN',
} as const;

const EXPERIMENT_CODE = {
  [EXPERIMENT_NAME.NEW_LOGGED_OUT_SCREEN]: 'ABACUS-435',
} as const;

const VARIANT = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
} as const;

export const EXPERIMENTS = {
  [EXPERIMENT_NAME.NEW_LOGGED_OUT_SCREEN]: {
    name: EXPERIMENT_CODE.NEW_LOGGED_OUT_SCREEN,
    variants: { [VARIANT.A]: VARIANT.A, [VARIANT.B]: VARIANT.B },
  },
} as const;
